import React from 'react';

/** An omission at step three clears every downstream hop and commits at step seven. */
export function AgentChain() {
  return <svg viewBox="0 0 460 150" fill="none" fontFamily="JetBrains Mono, monospace" fontSize="10" role="img" aria-label="An agent chain: an omission at step three passes through steps four onward and commits at step seven, with no reviewer between the steps." data-id="element-51" data-mp="14gmq8umexizq">
      <text x="0" y="14" fill="#7B838D" letterSpacing="1" data-id="element-52" data-mp="gu7vzpuz7lln">
        AGENT — NO ONE BETWEEN THE STEPS
      </text>
      <g transform="translate(0,30)" data-id="element-53" data-mp="lrzmqgjvx1o9">
        <rect x="0" y="0" width="40" height="28" fill="#fff" stroke="#CCD2DA" data-id="element-54" data-mp="qr2sk37ovbxa" />
        <text x="20" y="18" textAnchor="middle" fill="#4A504A" data-id="element-55" data-mp="qozwp2juuokn">
          1
        </text>
        <line x1="40" y1="14" x2="60" y2="14" stroke="#CCD2DA" data-id="element-56" data-mp="vjcfdadibvvc" />
        <rect x="60" y="0" width="40" height="28" fill="#fff" stroke="#CCD2DA" data-id="element-57" data-mp="3u6qf2v8a2ot3" />
        <text x="80" y="18" textAnchor="middle" fill="#4A504A" data-id="element-58" data-mp="30goen0t2bsk">
          2
        </text>
        <line x1="100" y1="14" x2="120" y2="14" stroke="#CCD2DA" data-id="element-59" data-mp="2d0rkh0qrkcye" />
        <rect x="120" y="0" width="108" height="28" fill="#fff" stroke="#C2543C" strokeDasharray="3 3" data-id="element-60" data-mp="2d2cij0caee10" />
        <text x="174" y="18" textAnchor="middle" fill="#b8492e" data-id="element-61" data-mp="23aosn3vdp51n">
          3 · omission
        </text>
        <line x1="228" y1="14" x2="248" y2="14" stroke="#C2543C" data-id="element-62" data-mp="1z93cn9njsan8" />
        <rect x="248" y="0" width="40" height="28" fill="#fff" stroke="#CCD2DA" data-id="element-63" data-mp="1z8uy7dbs0x9x" />
        <text x="268" y="18" textAnchor="middle" fill="#4A504A" data-id="element-64" data-mp="1uath2xxwv813">
          4
        </text>
        <line x1="288" y1="14" x2="308" y2="14" stroke="#C2543C" data-id="element-65" data-mp="1pa5paa1uyn5t" />
        <rect x="308" y="0" width="40" height="28" fill="#fff" stroke="#CCD2DA" data-id="element-66" data-mp="1kbavkd2cre6x" />
        <text x="328" y="18" textAnchor="middle" fill="#4A504A" data-id="element-67" data-mp="1ga8v5swp8w3d">
          …
        </text>
        <line x1="348" y1="14" x2="368" y2="14" stroke="#C2543C" data-id="element-68" data-mp="1gclmgwockit3" />
        <rect x="368" y="0" width="92" height="28" fill="#151A21" data-id="element-69" data-mp="3epbusz1te37j" />
        <text x="414" y="18" textAnchor="middle" fill="#fff" data-id="element-70" data-mp="3ao0bfb9jae7s">
          7 · commit
        </text>
      </g>
      <text x="0" y="118" fill="#98A0A8" fontSize="11" data-id="element-71" data-mp="180jxau53l5d9">
        the omission clears at step 7 — no reviewer was there
      </text>
    </svg>;
}